import QuickSterilizer from './QuickSterilizer';

export default QuickSterilizer;